import router from './router';
import socket from './socket';
import core from './core';
import modals from './modals';
import users from './users';
import projects from './projects';
import boards from './boards';
import folders from './folders';
import labels from './labels';
import lists from './lists';
import cards from './cards';
import attachments from './attachments';
import activities from './activities';
import commentActivities from './comment-activities';
import notifications from './notifications';
import cardRelations from './card-relations';

export default {
  ...router,
  ...socket,
  ...core,
  ...modals,
  ...users,
  ...projects,
  ...boards,
  ...folders,
  ...labels,
  ...lists,
  ...cards,
  ...attachments,
  ...activities,
  ...commentActivities,
  ...notifications,
  ...cardRelations,
};
